;(function(global, $){

	var layers;
	var maxZoom;
	var typeMap;
	var layerGroup;
	var backgroundColor;
	var leafletLayers;

	var Background = function(options){
		return new Background._init(options);
	}

	Background.prototype = {
	
		gestionaBackground: function(socCatalnunya){
			var self = this;
			var layerGroup = self.layerGroup;
			this.leafletLayers.forEach(function(layer){
				switch (socCatalnunya) {
					case SCOPE_VISTA_FORA:
						if (layer.options.scope === SCOPE_GLOBAL && !layerGroup.hasLayer(layer)){
							layer.addTo(layerGroup);
						}else if (layer.options.scope === SCOPE_CATALUNYA && layerGroup.hasLayer(layer)){
							layerGroup.removeLayer(layer);
						}else if(layer.options.scope === SCOPE_TOT && !layerGroup.hasLayer(layer)){
							layer.addTo(layerGroup);
						}
						break;
					case SCOPE_VISTA_DINS:
						if (layer.options.scope === SCOPE_CATALUNYA && !layerGroup.hasLayer(layer)){
							layer.addTo(layerGroup);
						}else if (layer.options.scope === SCOPE_GLOBAL && layerGroup.hasLayer(layer)){
							layerGroup.removeLayer(layer);
						}else if(layer.options.scope === SCOPE_TOT && !layerGroup.hasLayer(layer)){
							layer.addTo(layerGroup);
						}
						break;
					case SCOPE_VISTA_TOT:
						if(!layerGroup.hasLayer(layer)){
							layer.addTo(layerGroup);
						}
						break;
				}
			});
		},

		getVista: function(){
			var layerGroup = self.layerGroup;
			var scope_layers = null;
			this.leafletLayers.forEach(function(layer){
				if (scope_layers === null){
					scope_layers = layer.options.scope;
				}else if ((SCOPE_CATALUNYA === scope_layers) && (layer.options.scope === SCOPE_TOT || layer.options.scope === SCOPE_GLOBAL)){
					scope_layers = layer.options.scope;
				}
			});
			return scope_layers;
		},

		gestionaAttribution: function(){
			var attribution = [];
			this.layerGroup.eachLayer(function (layer) {
				attribution = attribution.concat(layer.options.attribution);
			});
			let unique = [...new Set(attribution)];
			var attribution = unique.map(function(item){
				return "<p>"+item+"</p>";
			});
			return attribution.join("");
		},

		gestionaBackgroundColor: function(socCatalnunya){
			if(this.backgroundColor){
				return this.backgroundColor[socCatalnunya] || null;
			}else{
				return null;
			}
		},

		createBackground: function(forPrint){
			var self = this;
			this.layers.forEach(element => {
				if(!element.hasOwnProperty('printable') || (forPrint && element.printable) || (!forPrint && !element.printable)){
					var createFunction;
					if(element.type === 'tileLayer') {
						createFunction = L.TileLayer;
					}else if (element.type === 'boundaryCanvas'){
						createFunction = L.TileLayer.boundaryCanvas;
					}
					var layer = new createFunction(element.url, element.options).addTo(self.layerGroup);
					this.leafletLayers.push(layer);
				}
			});
			return self.layerGroup
		},

		bringToBack: function(){
			this.layerGroup.eachLayer(function (layer) {
				try{
					layer.bringToBack();
				}catch(e){
	
				}
			});
		},
	};

	Background._init = function(options){
		this.layers = options.layers;
		this.maxZoom = options.maxZoom;
		this.typeMap = options.typeMap;
		this.layerGroup = L.layerGroup();
		this.backgroundColor = options.backgroundColor;
		this.leafletLayers = [];
	}

	Background._init.prototype = Background.prototype;
	Background.sortGeometry = Background.prototype.sortGeometry;
	Background.getUpdatedLayerName = Background.prototype._getNewLayerName;
	global.Background = Background;

}(window, jQuery));	